import React from 'react';

import {
  Box,
  Button,
  Paper,
  Typography,
  Color,
} from '@mui/material';

import LeftIcon from '@mui/icons-material/ChevronLeft';
import RightIcon from '@mui/icons-material/ChevronRight';

import useIsMobile from '../core/hooks/useIsMobile';

import FormPaper from './FormPaper';

interface IFormStepperBody {
  children: ({ activeStep }: { activeStep: number }) => React.ReactNode;
  color: Color;
  submitError?: boolean;
  lastSaved?: string | null;
  onClose?: () => void;
  submitText?: string;
  onStepChange: (step: number) => void;
  activeStep: number;
  lastStep: number;
}

function FormStepperBody({
  children,
  color,
  submitError,
  lastSaved,
  onClose,
  submitText,
  onStepChange,
  activeStep,
  lastStep,
}: IFormStepperBody): JSX.Element {
  const isMobile = useIsMobile();

  const handleStepChange = (step: number) => () => onStepChange(step);

  return (
    <FormPaper color={color}>
      <Paper variant="outlined" sx={{ p: isMobile ? 1 : 2 }}>
        {children({ activeStep })}
      </Paper>
      <Box sx={{ margin: 2, display: 'flex', justifyContent: 'space-between' }}>
        <Box>
          <Button onClick={onClose}>Close</Button>
        </Box>
        <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            disabled={activeStep === 0}
            onClick={handleStepChange(activeStep - 1)}
            sx={{ mr: 1 }}
          >
            <LeftIcon />
          </Button>
          <Button
            variant="outlined"
            color="primary"
            disabled={activeStep === lastStep}
            onClick={handleStepChange(activeStep + 1)}
            sx={{ ml: 1 }}
          >
            <RightIcon />
          </Button>
        </Box>
        <Box>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={(lastSaved === null || lastSaved === undefined)}
          >
            {`${submitText ?? 'Review'}`}
          </Button>
        </Box>
      </Box>
      {submitError && (
        <Box sx={{ margin: 2, display: 'flex', justifyContent: 'center' }}>
          <Typography color="error" variant="body2" align="right">
            Please verify all fields are entered correctly
          </Typography>
        </Box>
      )}
    </FormPaper>
  );
}

export default FormStepperBody;
